import React from 'react';
import ErrorAlert from "../../../components/UI/ErrorAlert";

function SubHeader(props) {
    const getSteps = () => {
        let steps = [];
        for (let i = 1; i <= props.step_count; i++) {
            let step;
            if (i < props.current_step) {
                step = <li className="application-step application-step--completed" key={i}>
                    <span className="icons icon-check text-primary"></span>
                </li>
            } else if (i === props.current_step) {
                step = <li className="application-step application-step--active" key={i}><span>{i}</span></li>
            } else {
                step = <li className="application-step application-step--inactive" key={i}><span>{i}</span></li>
            }
            steps.push(step);
        }
        return steps;
    };

    return (
        <div className="row">

            <div className="col-12 window-layout__head bg-fill-gray-cloud">
                <h2 className="window-layout__heading">{props.title}</h2>
                <ul className="application-steps window-layout__steps">
                    {getSteps()}
                </ul>
            </div>

            <div className="col-12">
                <ErrorAlert/>
            </div>

        </div>
    );
}

export default SubHeader;
